module.exports = __webpack_public_path__ + "1d81c5844d1b27b076afaff241c7a421.fbx";